import { withIcon } from '@optimizely/axiom-icons';

export const IconBellRegular = withIcon(
  {
    icon: [
      20,
      16,
      [],
      '',
      [
        'M10.0157 0C10.5469 0 11.0157 0.46875 11.0157 1V1.625C13.2969 2.0625 15.0157 4.09375 15.0157 6.5V7.3125C15.0157 8.71875 15.4844 10.0938 16.3594 11.2188L16.8282 11.7812C17.0157 12.0312 17.0469 12.3438 16.9219 12.5938C16.7969 12.8438 16.5469 13 16.2657 13H3.76567C3.45317 13 3.20317 12.8438 3.07817 12.5938C2.95317 12.3438 2.98442 12.0312 3.17192 11.7812L3.64067 11.2188C4.51567 10.0938 5.01567 8.71875 5.01567 7.3125V6.5C5.01567 4.09375 6.73442 2.0625 9.01567 1.625V1C9.01567 0.46875 9.45317 0 10.0157 0ZM10.0157 3C8.07817 3 6.51567 4.59375 6.51567 6.5V7.3125C6.51567 8.8125 6.07817 10.25 5.26567 11.5H14.7344C13.9219 10.25 13.5157 8.8125 13.5157 7.3125V6.5C13.5157 4.59375 11.9219 3 10.0157 3ZM12.0157 14C12.0157 14.5312 11.7969 15.0625 11.4219 15.4375C11.0469 15.8125 10.5469 16 10.0157 16C9.48442 16 8.95317 15.8125 8.57817 15.4375C8.20317 15.0625 8.01567 14.5312 8.01567 14H12.0157Z',
      ],
    ],
    iconName: 'bell-regular',
    prefix: 'ax',
  },
  'IconBellRegular'
);
